import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { AdminPermissions } from 'app/library/feature/enums/admin-permissions.enum';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { FetchTeamWithSubTeamsProgress, FetchTeamWithSubTeamsProgressFailure, FetchTeamWithSubTeamsProgressSuccess } from '../actions';
import { TeamState } from '../models/team.state';
import { TrackTeamSubTeamProgressService } from './track-team-subteam-progress.service';

@Injectable()
export class TeamResolver  {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper, private _trackTeamSubTeamProgressService: TrackTeamSubTeamProgressService) {}

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const teamId = route.params['teamId'];

        const includeSubTeamsProgress = !this._trackTeamSubTeamProgressService.isTrackTeamSubTeamProgressExcluded(teamId);
        this._store.dispatch(new FetchTeamWithSubTeamsProgress({ teamId, includeSubTeamsProgress }));

        const isFetched = await this._actionHelper.race(FetchTeamWithSubTeamsProgressSuccess, FetchTeamWithSubTeamsProgressFailure).toPromise();

        if (isFetched) {
            const team = this._store.selectSnapshot(TeamState.getEntity);
            const profile = this._store.selectSnapshot(UserState.getMyInfo);
            const hasTenantAdminOrUsersWritePermission =
                profile.permissions.includes(AdminPermissions.TEAMS_WRITE) || profile.permissions.includes(AdminPermissions.TENANT_MANAGEMENT);

            if (
                team.isCurrentUserWatcher ||
                team.isCurrentUserLeader ||
                team.isCurrentUserTrainingResponsible ||
                team.isCurrentUserUpperTrainingResponsible ||
                team.isCurrentUserTeamLeaderSubteams ||
                hasTenantAdminOrUsersWritePermission
            ) {
                return true;
            }
        }

        this._store.dispatch(new Navigate(['/my-teams']));
        return false;
    }
}
